<template>
  <div class="comp-xl-tree-organization">
    <div class="tree-member-select-tree">
      <div class="tree-search-wrap">
        <!-- 搜索 -->
        <input v-if="treeAttr.searchPlaceholder" :placeholder="treeAttr.searchPlaceholder" v-model="filterText" class="tree-search" @change="searchLeave" @input="memberInput" />
        <icon-close-circle class="icon-close" v-if="filterText" @click="clearSearch" />
      </div>
      <div class="xl-tree-wrap" :class="treeAttr.searchPlaceholder ? '' : 'xl-tree-wrap-height'">
        <!-- 默认展示的列表 -->
        <template v-if="!filterText && leaveJob.leaveJobType === 1">
          <!-- 面包屑 -->
          <div class="member-breadcrumb" v-if="breadcrumbList && breadcrumbList.length">
            <span class="member-breadcrumb-item member-breadcrumb-link" :title="treeAttr.breadcrumb || $t('组织架构')" @click="defaultBreadcrumb">
              <span>{{ treeAttr.breadcrumb || $t('组织架构') }}</span>
            </span>
            <i> &gt; </i>
            <template v-for="(item, index) in breadcrumbList" :key="item[treeAttr.props.id]">
              <span class="member-breadcrumb-item" :class="breadcrumbList.length - 1 != index ? 'member-breadcrumb-link' : ''" :title="item[treeAttr.props.label]" @click="handleBreadcrumb(item, index, breadcrumbList.length - 1 != index)">
                <span>{{ item[treeAttr.props.label] }}</span>
              </span>
              <i v-if="breadcrumbList.length - 1 != index"> &gt; </i>
            </template>
          </div>
          <div class="member-tree-list">
            <template v-if="treeAttr.props.id">
              <div class="tree-list-item" v-for="(item, index) in treeData" :key="item[treeAttr.props.id] || item[treeAttr.props.label] + '_' + index">
                <!-- 多选-->
                <template v-if="multipleDep">
                  <!-- 只能选部门 不能选人-->
                  <template v-if="treeAttr.checkDepartment && !treeAttr.checkUser">
                    <jw-checkbox class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleCheckbox($event, item)">
                      <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                      <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                      <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                      <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                    </jw-checkbox>
                  </template>
                  <!-- 人员多选-能选部门和人 -->
                  <template v-else-if="treeAttr.checkDepartment && treeAttr.checkUser">
                    <jw-checkbox class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleCheckbox($event, item)">
                      <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                      <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                      <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                      <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                    </jw-checkbox>
                  </template>
                  <!-- 人员多选-只能选人（不能选部门） -->
                  <template v-else-if="!treeAttr.checkDepartment && treeAttr.checkUser">
                    <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                    <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                    <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                    <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                  </template>
                  <!-- 不能选部门 -->
                  <!-- <template v-else>
                    <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                    <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                    <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                    <span class="depart-count" v-if="item[treeAttr.props.countKey]">({{ item[treeAttr.props.countKey] }})</span>
                  </template> -->
                </template>
                <!--单选  -->
                <div class="depart-name-info" v-else>
                  <!--可选公司/部门  -->
                  <jw-radio class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleCheckbox($event, item)" v-if="treeAttr.checkDepartment">
                    <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                    <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                    <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                    <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                  </jw-radio>
                  <!-- 不能选部门 -->
                  <template v-else>
                    <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                    <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                    <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                    <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                  </template>
                </div>
                <i class="ms-depart-i" :class="{ 'depart-disabled': item.disabled || item.ckb }" @click="handleDepartment(item)">{{ $t('下级') }}</i>
              </div>
              <!-- 用户加载中 S -->
              <!-- <div class="ms-empty" v-if="searchLoading">{{ $t('加载中') }}……</div> -->
              <jw-spin v-if="searchLoading" class="ms-empty"></jw-spin>
              <template v-else>
                <div class="tree-list-item" v-for="(item, index) in currentUsers" :key="item[treeAttr.userProps.id] || item[treeAttr.userProps.label] + '_' + index">
                  <!-- 最多可选多个人员 -->
                  <template v-if="multipleDep">
                    <jw-checkbox class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleUserCheckbox(item)">
                      <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
                      <template v-else>
                        <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                          <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
                        </jw-avatar>
                      </template>
                      <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
                      <jw-tag v-if="item?.leader" class="depart-user-leader" size="small" color="arcoblue">{{ $t('负责人') }}</jw-tag>
                      <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
                    </jw-checkbox>
                  </template>
                  <!-- 只能选择一个人员 -->
                  <template v-else>
                    <jw-radio class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleUserCheckbox(item)">
                      <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
                      <template v-else>
                        <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                          <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
                        </jw-avatar>
                      </template>
                      <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
                      <jw-tag v-if="item?.leader" class="depart-user-leader" size="small" color="arcoblue">{{ $t('负责人') }}</jw-tag>
                      <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
                    </jw-radio>
                  </template>
                </div>

                <div class="ms-empty" v-if="!treeData?.length && !currentUsers?.length">{{ $t('暂无数据，请返回上级') }}</div>
              </template>
              <!-- 用户加载中 E -->
            </template>
            <template v-else> props.id{{ $t('参数为必传参数') }}. </template>
          </div>
        </template>
        <!-- *****************************************************************离职************************************************************************************ -->
        <template v-else-if="leaveJob.leaveJobType === 0">
          <!-- <div class="ms-empty" v-if="searchLoading">{{ $t('加载中') }}……</div>
          <div class="tree-list-item" v-else v-for="(item, index) in leaveJobList" :key="item[treeAttr.userProps.id] || item[treeAttr.userProps.label] + '_' + index">
            <template v-if="memberNumber != 1">
              <jw-checkbox class="ms-ckb" v-model="item.ckb" @change="handleUserCheckbox(item)">
                <img class="ms-user-avator" :src="item[treeAttr.userProps.avator] || treeAttr.userProps.defaultAvator || iconUser" :alt="item[treeAttr.props.label]" />
                <span class="depart-user-name" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
              </jw-checkbox>
            </template>
            <template v-else>
              <jw-radio class="ms-ckb" v-model="item.ckb" @change="handleUserCheckbox(item)">
                <img class="ms-user-avator" :src="item[treeAttr.userProps.avator] || treeAttr.userProps.defaultAvator || iconUser" :alt="item[treeAttr.props.label]" />
                <span class="depart-user-name" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
              </jw-radio>
            </template>
          </div> -->
          <!-- <div class="ms-empty" v-if="searchLoading">{{ $t('加载中') }}……</div> -->
          <jw-spin v-if="searchLoading" class="ms-empty"></jw-spin>
          <div class="tree-list-item" v-else v-for="(item, index) in leaveJobList" :key="item[treeAttr.userProps.id] || item[treeAttr.userProps.label] + '_' + index">
            <!-- 最多可选多个人员 -->
            <template v-if="multipleDep">
              <jw-checkbox class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleUserCheckbox(item)">
                <!-- <img class="ms-user-avator" :src="item[treeAttr.userProps.avator] || treeAttr.userProps.defaultAvator || iconUser" :alt="item[treeAttr.props.label]" /> -->
                <!-- <xl-avatar :avatar="{ name: '', url: item[treeAttr.userProps.avator], id: item?.id }" /> -->
                <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
                <template v-else>
                  <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                    <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
                  </jw-avatar>
                </template>
                <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
                <jw-tag v-if="item?.leader" class="depart-user-leader" size="small" color="arcoblue">{{ $t('负责人') }}</jw-tag>
                <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
              </jw-checkbox>
            </template>
            <!-- 只能选择一个人员 -->
            <template v-else>
              <jw-radio class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleUserCheckbox(item)">
                <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
                <template v-else>
                  <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                    <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
                  </jw-avatar>
                </template>
                <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
                <jw-tag v-if="item?.leader" class="depart-user-leader" size="small" color="arcoblue">{{ $t('负责人') }}</jw-tag>
                <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
              </jw-radio>
            </template>
            <div class="ms-empty" v-if="!leaveJobList.length">{{ $t('暂无搜索结果，请更换搜索关键字') }}</div>
          </div>
        </template>
        <!-- *****************************************************************离职************************************************************************************ -->
        <!-- 以下是搜索显示的结构 -->
        <template v-else>
          <!-- <div class="ms-empty" v-if="searchLoading">{{ $t('加载中') }}……</div> -->
          <jw-spin v-if="searchLoading" class="ms-empty"></jw-spin>
          <template v-else>
            <!-- 搜索出来的部门 -->
            <template v-if="getSearchDepsList && getSearchDepsList?.length > 0">
              <div class="tree-list-item" v-for="(item, index) in getSearchDepsList" :key="item[treeAttr.props.id] || item[treeAttr.props.label] + '_' + index">
                <!-- 可以选部门/公司-->
                <!-- 多选 -->
                <jw-checkbox class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleCheckbox($event, item)" v-if="multipleDep">
                  <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                  <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                  <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                  <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                </jw-checkbox>
                <!-- 单选 -->
                <jw-radio class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleCheckbox($event, item)" v-else>
                  <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
                  <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '自建' }}</jw-tag>
                  <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
                  <span class="depart-count">({{ item[treeAttr.props.countKey] }}人)</span>
                </jw-radio>
              </div>
            </template>
            <!-- 搜索出来的人员 -->
            <template v-if="getSearchUsersList && getSearchUsersList?.length > 0">
              <div class="tree-list-item" v-for="(item, index) in getSearchUsersList" :key="item[treeAttr.userProps.id] || item[treeAttr.userProps.label] + '_' + index">
                <!-- 最多可选多个人员 -->
                <template v-if="multipleDep">
                  <jw-checkbox class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleUserCheckbox(item)">
                    <!-- <img class="ms-user-avator" :src="item[treeAttr.userProps.avator] || treeAttr.userProps.defaultAvator || iconUser" :alt="item[treeAttr.props.label]" /> -->
                    <!-- <xl-avatar :avatar="{ name: '', url: item[treeAttr.userProps.avator], id: item?.id }" /> -->
                    <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
                    <template v-else>
                      <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                        <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
                      </jw-avatar>
                    </template>
                    <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
                    <jw-tag v-if="item?.leader" class="depart-user-leader" size="small" color="arcoblue">{{ $t('负责人') }}</jw-tag>
                    <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
                  </jw-checkbox>
                </template>
                <!-- 只能选择一个人员 -->
                <template v-else>
                  <jw-radio class="ms-ckb" v-model="item.ckb" :disabled="item.disabled" @change="handleUserCheckbox(item)">
                    <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
                    <template v-else>
                      <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                        <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
                      </jw-avatar>
                    </template>
                    <span class="depart-user-name" :class="{ 'depart-disabled': item.disabled }" :title="item[treeAttr.userProps.label]">{{ item[treeAttr.userProps.label] }}</span>
                    <jw-tag v-if="item?.leader" class="depart-user-leader" size="small" color="arcoblue">{{ $t('负责人') }}</jw-tag>
                    <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
                  </jw-radio>
                </template>
              </div>
            </template>
            <div class="ms-empty" v-if="!getSearchDepsList?.length && !getSearchUsersList?.length">{{ $t('暂无搜索结果，请更换搜索关键字') }}</div>
          </template>
        </template>
      </div>
    </div>
    <div class="tree-member-select-data">
      <div class="tree-list-hd">
        <template v-if="getCurData().d || getCurData().u">
          <template v-if="getCurData().u">{{ $t('已选') + treeAttr.userProps.text || $t('人员') + $t('数') }}：{{ getCurData().u + `${memberNumber ? `/${memberNumber}` : ''}` }} </template>
          <template v-if="getCurData().d && getCurData().u">，</template>
          <template v-if="getCurData().d">{{ $t('已选') + treeAttr.props.text || $t('部门') + $t('数') }}：{{ getCurData().d }}</template>
          <a href="javascript:;" class="clear-all" @click="clearAll" v-if="getCurData().t && getCurData().t > 5">{{ $t('清空') }}</a>
        </template>
        <template v-else>{{ $t('请选择') }}</template>
      </div>
      <div class="tree-list-inline">
        <!-- 已选部门 -->
        <ul v-if="checkDepartList.length || checkUserList.length">
          <li class="depart" v-for="(item, index) in checkDepartList" :key="item[treeAttr.props.id] || item[treeAttr.props.label] + '_' + index" :title="item[treeAttr.props.label]">
            <span class="ms-depart-avator" v-if="item.departmentName">{{ item.departmentName?.substring(0, 2) }}</span>
            <jw-tag size="small" color="blue" v-if="item.platform == 2">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
            <span class="depart-user-name" :title="item[treeAttr.props.label]">{{ item[treeAttr.props.label] }}</span>
            <span class="depart-count" v-if="item[treeAttr.props.countKey]">({{ item[treeAttr.props.countKey] }}人)</span>
            <icon-close-circle class="del" v-if="!disabledIds.find((ele) => ele === item[treeAttr.props.id])" @click="delItem(1, item)" />
          </li>
          <!-- 已选人员 -->
          <li v-for="(item, index) in checkUserList" :key="item[treeAttr.userProps.id] || item[treeAttr.userProps.label] + '_' + (checkDepartList.length + 100) + index" :title="item[treeAttr.userProps.label]">
            <!-- <img class="ms-user-avator" :src="item[treeAttr.userProps.avator] || treeAttr.userProps.defaultAvator || iconUser" :alt="item[treeAttr.props.label]" /> -->
            <img class="ms-user-avator" v-if="item[treeAttr.userProps.avator]" :src="item[treeAttr.userProps.avator]" :alt="item[treeAttr.props.label]" />
            <template v-else>
              <jw-avatar :style="{ backgroundColor: color(item?.id), width: '32px', height: '32px', marginRight: '5px' }">
                <span style="padding: 0 6px">{{ item[treeAttr.userProps.label]?.slice(item[treeAttr.userProps.label].length - 2) }}</span>
              </jw-avatar>
            </template>
            <span>{{ item[treeAttr.userProps.label] }}</span>
            <jw-tag size="small" color="blue" v-if="item.platform == 2" style="margin-left: 5px">{{ item.platform == 2 ? '飞书' : '' }}</jw-tag>
            <icon-close-circle class="del" v-if="!disabledIds.find((ele) => ele === item[treeAttr.props.id])" @click="delItem(2, item)" />
          </li>
        </ul>
        <div class="ms-empty" v-else>{{ $t('暂无数据，请先选择') }}</div>
      </div>
    </div>
    <jw-modal title-align="start" v-model:visible="isModalNotice" :title="$t('提示')" :popup-container="popup" @ok="onOk" @cancel="onCancel">
      {{ modalContentText }}
    </jw-modal>
  </div>
</template>

<script setup>
// import iconOrg from './images/icon-organization.png';
//import iconUser from './images/icon-user-avator.png';//
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import { onMounted, computed, nextTick, ref, watch } from 'vue';
import { orgService } from '@/api';
const { t } = useI18n();
const filterText = ref(''); // 搜索用户
const breadcrumbList = ref([]); // 面包屑导航
const currentUsers = ref([]); // 当前部门下的人员
const getSearchDepsList = ref([]); //搜索出来的部门
const getSearchUsersList = ref([]); //搜索出来的人员
const treeCurrent = ref(null); //当前选中的tree 位置
const treeData = ref([]);
const searchLoading = ref(true);
const nextLevel = ref(true);
const timer = ref(null);
const leaveJobArray = ref([]);
const copyLeaveJobArray = ref([]);
const props = defineProps({
  popup: {
    type: String,
    default: 'body'
  },
  memberNumber: {
    //可选人数数量 0:不限制
    type: Number,
    default: 0
  },
  //true：多选 false: 单选
  multipleDep: {
    type: Boolean,
    default: true
  },
  // 选中的值
  checkDepartList: {
    type: Array,
    default: () => {
      return [];
    }
  },
  checkUserList: {
    type: Array,
    default: () => {
      return [];
    }
  },
  tree: {
    type: Object,
    default: () => {
      return {
        props: {},
        userProps: {}
      };
    }
  },
  leaveJob: {
    type: Object,
    default: () => {
      return {
        leaveJobType: 1
      };
    }
  },
  disabledIds: {
    //需要禁用的数据id
    type: Array,
    default: () => {
      return [];
    }
  }
});
const emits = defineEmits(['update:checkDepartList', 'update:checkUserList']);
const colors = ['#f53f3f', '#7816ff', '#00b42a', '#165dff', '#ff7d00', '#eb0aa4', '#7bc616', '#ffb400', '#b71de8', '#0fc6c2'];
const color = (id) => {
  let getId = id;
  getId = getId + '';
  const i = getId.substr(-1, 1);
  return colors[i];
};
const treeAttr = computed(() => {
  return { ...props.tree };
});

// 离职人员数据 追加ckb
const leaveJobList = computed(() => {
  const treeData = JSON.parse(JSON.stringify(leaveJobArray.value));
  const departId = treeAttr.value.props.id;
  const td = treeData.map((el) => {
    el.ckb = false;
    if (props.checkDepartList.find((ele) => ele[departId] == el[departId])) {
      el.ckb = true;
    }
    return { ...el };
  });
  return td;
});

// 初始化节点选中状态
const traverseAndSetCheckedStatus = (node, checkDepartList, departId) => {
  // 确保每个节点都有 ckb 属性，并初始化为 false
  node.ckb = false;
  node.disabled = false;
  // 如果节点id存在于已选部门列表中，则设置 ckb 为 true
  if (checkDepartList.find((ele) => ele[departId] == node[departId])) {
    node.ckb = true;
  }
  // 是否禁用
  if (props.disabledIds.find((ele) => ele == node[departId])) {
    node.disabled = true;
  }
  // 遍历子节点（如果存在的话）
  if (Array.isArray(node.children)) {
    node.children.forEach((childNode) => {
      traverseAndSetCheckedStatus(childNode, checkDepartList);
    });
  }
};
// 获取组织机构数据
const getTreeData = (treeData, checkDepartList, departId) => {
  const clonedData = JSON.parse(JSON.stringify(treeData));
  clonedData.forEach((rootNode) => {
    traverseAndSetCheckedStatus(rootNode, checkDepartList, departId);
  });
  return clonedData;
};
// 当前展示的tree数据
const currentDepartmentArr = () => {
  treeData.value = getTreeData(props.tree.data, props.checkDepartList, treeAttr.value.props.id);
  searchLoading.value = false;
};
// 计算当前选中的人和部门
const getCurData = () => {
  const d = props.checkDepartList;
  const u = props.checkUserList;
  return { d: d.length, u: u.length, t: d.length + u.length };
};
// 打开下级tree
const handleDepartment = (data) => {
  if (data.ckb) return; // 选中状态不可打开
  if (data.disabled) return; // 禁用状态不可打开
  if (data) {
    treeData.value = [];
    treeCurrent.value = data[treeAttr.value.props.id]; //当前点击的tree信息
    treeData.value = data.children; //加载下级部门信息

    if (treeAttr.value.checkUser) {
      //能选人员时加载人员列表
      getSubUsers();
    }

    breadcrumbList.value.push(data); //面包屑
    getDepartmentCkb(treeData.value); //更新选中状态
    nextLevel.value = false;
    emits('cb');
  }
};
const containsDisabledId = (obj, disabledIds) => {
  return disabledIds.some((id) => obj.some((item) => item.id == id));
};
// 点击部门选中切换
const isModalNotice = ref(false);
const modalContentText = ref('');
const tmpData = ref(null);
const onOk = () => {
  tmpData.value.ckb = true;
  handleDepartCheckbox(tmpData.value);
};
const onCancel = () => {
  tmpData.value.ckb = false;
  handleDepartCheckbox(tmpData.value);
};
const handleCheckbox = (v, data) => {
  if (!props.multipleDep && containsDisabledId(props.checkDepartList, props.disabledIds)) {
    data.ckb = false;
    return;
  } //单选且有禁用的列表
  const child = data[treeAttr.value.props.children];
  const childText = treeAttr.value.props.text;
  console.log(props.popup, '###props.popup');
  if (child && child.length && data.ckb === true) {
    modalContentText.value = `${t('你所选择的')}${childText || t('部门')}${t('包含下级')}${childText || t('部门')}，${t('是否确认选择')}`;
    isModalNotice.value = true;
    tmpData.value = data;
    // Modal.success({
    //   title: t('提示'),
    //   content: `${t('你所选择的')}${childText || t('部门')}${t('包含下级')}${childText || t('部门')}，${t('是否确认选择')}`,
    //   okText: t('确定'),
    //   cancelText: t('取消'),
    //   mask: true,
    //   okLoading: true,
    //   hideCancel: false,
    //   maskClosable: false,
    //   renderToBody: false,
    //   popupContainer: props.popup,
    //   onOk: () => {
    //     data.ckb = true;
    //     handleDepartCheckbox(data);
    //   },
    //   onCancel: () => {
    //     data.ckb = false;
    //     handleDepartCheckbox(data);
    //   }
    // });
  } else {
    data.ckb = v;
    handleDepartCheckbox(data);
  }
};
// 点击部门前面的选中切换事件
const handleDepartCheckbox = (data) => {
  let arr = [];
  if (data.ckb) {
    //选中
    if (props.multipleDep) {
      //多选
      arr = [...props.checkDepartList, data];
    } else {
      arr = [data];
    }
  } else {
    //反选
    const departId = treeAttr.value.props.id;
    arr = props.checkDepartList.filter((item) => data[departId] && item[departId] != data[departId]);
  }
  emits('update:checkDepartList', arr);
};
// 点击人员选中切换
const handleUserCheckbox = (data) => {
  if (!props.multipleDep && containsDisabledId(props.checkUserList, props.disabledIds)) {
    data.ckb = false;
    return;
  } //单选且有禁用的列表
  if (data.ckb && props.memberNumber > 1 && props.checkUserList.length >= props.memberNumber) {
    Message.warning(`${t('最多可选')}${props.memberNumber}`);
    data.ckb = false;
    return false;
  }
  let arr = [];
  if (data.ckb) {
    if (props.multipleDep) {
      arr = [...props.checkUserList, data];
    } else {
      arr = [data];
      nextTick(() => {
        getUserCkb(currentUsers.value);
        getUserCkb(leaveJobList.value);
      });
    }
  } else {
    const userId = treeAttr.value.userProps.id;
    arr = props.checkUserList.filter((item) => data[userId] && item[userId] != data[userId]);
  }
  emits('update:checkUserList', arr);
};
// 面包屑恢复默认
const defaultBreadcrumb = () => {
  breadcrumbList.value = [];
  currentUsers.value = [];
  treeCurrent.value = null;
  currentDepartmentArr(); //恢复数据
  getDepartmentCkb(treeData.value);
  nextLevel.value = true;
  emits('cb', props.checkDepartList);
};
// 切换面包屑位置
const handleBreadcrumb = (data, index, flag) => {
  if (!flag) return;
  breadcrumbList.value = breadcrumbList.value.slice(0, index + 1);
  treeCurrent.value = data[treeAttr.value.props.id];
  treeData.value = [];
  treeData.value = data.children;
  getDepartmentCkb(treeData.value);
  nextLevel.value = false;
  if (treeAttr.value.checkUser) {
    //可选人员加载人员列表
    getSubUsers();
  }
  emits('cb');
};
// 更新部门否选中状态
const getDepartmentCkb = (data) => {
  const departId = treeAttr.value.props.id;

  data?.forEach((item) => {
    item.ckb = props.checkDepartList.some((v) => v[departId] && item[departId] && v[departId] == item[departId]);
    item.disabled = props.disabledIds.some((v) => v && item[departId] && v == item[departId]);
  });
};
// 人员是否选中状态
const getUserCkb = (data) => {
  const userId = treeAttr.value.userProps.id;
  data?.forEach((item) => {
    item.ckb = props.checkUserList.some((v) => v[userId] && item[userId] && v[userId] == item[userId]);
    item.disabled = props.disabledIds.some((v) => v && item[userId] && v == item[userId]);
  });
};

// 搜索/离职人员
const searchLeave = async (value) => {
  //  leaveJobType  1 在职 0 离职
  if (props.leaveJob.leaveJobType === 1) return;
  clearTimeout(timer.value);
  searchLoading.value = true;
  timer.value = setTimeout(async () => {
    await getleavePeople(value.target.value);
    searchLoading.value = false;
  }, 2000);
  return;
};
// 搜索/离职人员
const getleavePeople = async (value, copy) => {
  try {
    const params = { page: 1, pageSize: 9999, userName: value };
    const json = await orgService.getPersonList(params);
    if (!json?.error) {
      leaveJobArray.value = json?.result?.records || [];
      if (copy) copyLeaveJobArray.value = JSON.parse(JSON.stringify(leaveJobArray.value));
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};

// 搜索部门/人员
const memberInput = async () => {
  //  leaveJobType  1 在职 0 离职
  if (props.leaveJob.leaveJobType === 0) return;

  clearTimeout(timer.value);
  searchLoading.value = true;
  if (nextLevel.value && !filterText.value) {
    emits('cb', props.checkDepartList);
  } else {
    emits('cb');
  }

  timer.value = setTimeout(async () => {
    await getUserAndDeptByKeyWord();
    searchLoading.value = false;
  }, 700);
};
// 搜索部门/人员
const getUserAndDeptByKeyWord = async () => {
  getSearchUsersList.value = [];
  getSearchDepsList.value = [];
  searchLoading.value = true;
  const data = {
    departmentId: treeCurrent.value || '',
    all: treeAttr.value.isAll || false,
    keyWord: filterText.value || '',
    userSelector: treeAttr.value.userSelector
  };
  const json = await orgService.searchDepartUserList(data);
  if (!json.error) {
    const list = json.result;
    getSearchUsersList.value = treeAttr.value.checkUser ? list?.userList : []; // 能选人员时才展示搜索的用户
    getSearchDepsList.value = treeAttr.value.checkDepartment || (treeAttr.value.checkUser && props.multipleDep && !treeAttr.value.checkDepartment) ? list?.deptList : []; //1.能选部门 2.只能选人员且多选
    getDepartmentCkb(getSearchDepsList.value); //更新部门选中状态
    getUserCkb(getSearchUsersList.value); //更新人员选中状态
  }

  searchLoading.value = false;
};
// 清空人员
const clearSearch = () => {
  filterText.value = '';
  if (nextLevel.value) {
    emits('cb', props.checkDepartList);
  }
  leaveJobArray.value = copyLeaveJobArray.value;
};
// 获取部门下人员
const getSubUsers = async () => {
  currentUsers.value = [];
  searchLoading.value = true;
  const p = { page: 1, pageSize: 999, fetchChild: false, userName: filterText.value || '', departmentId: treeCurrent.value, all: treeAttr.value.isAll || false, userSelector: treeAttr.value.userSelector };
  const json = await orgService.getDepartUserList.bind(orgService)(p);
  if (!json.error) {
    let list = json.result?.records || [];
    list = list.map((el) => {
      return Object.assign({ ckb: false, disabled: false }, el);
    });
    currentUsers.value = list;
    getUserCkb(currentUsers.value);
  }

  searchLoading.value = false;
};
// 删除部门或用户 tp：1(部门) 2(人员)
const delItem = (tp, data) => {
  if (data.disabled) return;
  if (tp == 1) {
    // const arr = props.checkDepartList;
    // arr.splice(index, 1);
    const departId = treeAttr.value.props.id;
    const arr = props.checkDepartList.filter((item) => data[departId] && item[departId] != data[departId]);

    getDepartmentCkb(treeData.value); //跟新原数据部门选中状态
    getDepartmentCkb(getSearchDepsList.value); //更新搜索出来的部门选中状态
    emits('update:checkDepartList', arr);
    if (nextLevel.value && !filterText.value) {
      emits('cb', arr);
    }
  } else {
    // const arr = props.checkUserList;
    // arr.splice(index, 1);
    const userId = treeAttr.value.userProps.id;
    const arr = props.checkUserList.filter((item) => data[userId] && item[userId] != data[userId]);
    emits('update:checkUserList', arr);
  }
};

// 清空数据
const clearAll = () => {
  emits('update:checkDepartList', []);
  emits('update:checkUserList', []);
};
watch(
  () => props.checkDepartList,
  () => {
    getDepartmentCkb(treeData.value); //跟新原数据部门选中状态
    getDepartmentCkb(getSearchDepsList.value); //更新搜索出来的部门选中状态
  }
);
watch(
  () => props.checkUserList,
  () => {
    getUserCkb(currentUsers.value); //更新部门下人员选中状态
    getUserCkb(getSearchUsersList.value); //更新人员选中状态
    getUserCkb(leaveJobList.value);
  },
  {
    deep: true
  }
);
watch(
  () => leaveJobList,
  () => {
    getUserCkb(leaveJobList.value);
  },
  {
    deep: true
  }
);

onMounted(() => {
  getleavePeople('', 'copy');
});
defineExpose({ currentDepartmentArr });
</script>
<style scoped lang="less">
@import './xl-tree-org.less';
</style>
